<style lang="less" scoped>
.wjhg{position: relative;width: 100%;margin: 20px auto;padding: 0;background: #fff;}
.main{position: relative;display: flex;flex-direction: column;justify-content: center;width: 1200px;margin: auto;}
.Previous{margin-left: 60px;margin-bottom: 40px;}
.left{margin-top: 20px;}
.bmhf{width:1200px; height: 179px;margin: 30px auto;}
</style>

<template>
  <div class="wjhg">
    <div class="main">
      <div class="left">
        <Previousreview class="Previous" :cardlist="Cardlist"></Previousreview>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 李旭  2021.6.15 往届回顾页面
 */
import Previousreview from '../assembly/Previousreview'
export default {
  components: { Previousreview },
  created()
  {
    this.getWjhg()
  },
  data()
  {
    return {
      cardlist: []
    }
  },
  computed: {
    Cardlist()
    {
      return this.cardlist
    }
  },
  methods: {
    /**
     * 获取往届回顾
     */
    getWjhg()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: 'moduleid = 20 and id != 28 and id != 41', orderby: 'id desc'}
      window.post.getPost(paras).then((ret) =>
      {
        ret.forEach((item, index) =>
        {
          this.cardlist.push({num: (index + 1).toString(), title: item.dispc, catid: item.id})
        })
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/project/Oldnews.vue